// GENEROWANE z opisu linii w workerze Go: `worker tool typy` (worker-go/tools/typy).
// Nie edytować ręcznie - zmiana kontraktu = zmiana opisu w Go i ponowne wygenerowanie (KN-2).

import type { ViewDoc } from "../kontrakt";

export interface PolaSterownik650 {
  t_condenser: number | null;
  t_water: number | null;
  t_shelf10: number | null;
  t_buffer: number | null;
  t_tank: number | null;
  t_jacket: number | null;
  t_day: number | null;
  polm: boolean | null;
  process_s: number | null;
  olm_s: number | null;
  warmup_s: number | null;
  phase_s: number | null;
  dumps_done: number | null;
  dumps_planned: number | null;
  buffer_unstable: boolean | null;
  rssi: number | null;
}

export interface NastawySterownik650 {
  ileZrzutow: number | null;
  czasLM: number | null;
  mocRobocza: number | null;
  minimalnyOLM: number | null;
  maxOLM: number | null;
  abratek: boolean | null;
  NTC: boolean | null;
  maleZrzuty: boolean | null;
  pracaBuforem: boolean | null;
  czasPlukania: number | null;
  proces: 1 | 2 | 3 | null;
  zacier: boolean | null;
  tempZacierania: number | null;
  ustawTempDnia: number | null;
  tempH2oStop: number | null;
  tempUFOstop: number | null;
  korUFO: number | null;
  kor10p: number | null;
  korBufor: number | null;
  korZbiornik: number | null;
  ktzjb: number | null;
  ktbc: number | null;
  stopTime: number | null;
  ktzbb: number | null;
  ktbt: number | null;
  deltaTempDnia: number | null;
  histTempDnia: number | null;
  stab1czas: number | null;
  stab3czas: number | null;
  stab2czas: number | null;
  deltaBufor: number | null;
  G2rob: boolean | null;
  G3rob: boolean | null;
  G1: number | null;
  G2: boolean | null;
  G3: boolean | null;
  EZolm: number | null;
  EZlm: boolean | null;
  EZh2o: boolean | null;
  light: boolean | null;
  mixer: boolean | null;
  trybAuto: boolean | null;
  praca: boolean | null;
}

/** Stan procesu w widoku (`state`) - etykiety z opisu procesu linii. */
export type StanSterownik650 = "BLAD_POMIARU" | "BRAK_CZUJNIKOW" | "KONIEC" | "ODBIOR_OLM" | "ODBIOR_PRZEDGONU_LM" | "PLUKANIE_OLM" | "ROZGRZEWANIE" | "SKOK_10P_STABILIZUJE" | "STABILIZACJA" | "STABILIZACJA_KONCOWA" | "STOP" | "STOP_AWARIA" | "STOP_KOMUNIKACJA" | "STOP_PRZEGRZANIE";

export interface WidokSterownik650 extends Omit<ViewDoc, "fields" | "settings" | "no_sensor" | "state"> {
  type: "sterownik-650";
  state?: StanSterownik650;
  fields: PolaSterownik650;
  settings?: NastawySterownik650;
  no_sensor?: Array<keyof PolaSterownik650>;
}

export const KOMENDY_STEROWNIK650 = {
  "nastawy": {
    "EZh2o": {
      "rodzaj": "wl_wyl",
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "EZlm": {
      "rodzaj": "wl_wyl",
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie",
      "blokada": [
        "EZolm"
      ]
    },
    "EZolm": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 100,
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie",
      "blokada": [
        "EZlm"
      ]
    },
    "G1": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 100,
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "G2": {
      "rodzaj": "wl_wyl",
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "G2rob": {
      "rodzaj": "wl_wyl",
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "G3": {
      "rodzaj": "wl_wyl",
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "G3rob": {
      "rodzaj": "wl_wyl",
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "NTC": {
      "rodzaj": "wl_wyl",
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "abratek": {
      "rodzaj": "wl_wyl",
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "czasLM": {
      "rodzaj": "liczba",
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "czasPlukania": {
      "rodzaj": "liczba",
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "deltaBufor": {
      "rodzaj": "liczba",
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "deltaTempDnia": {
      "rodzaj": "liczba",
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "histTempDnia": {
      "rodzaj": "liczba",
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "ileZrzutow": {
      "rodzaj": "liczba",
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "kor10p": {
      "rodzaj": "liczba",
      "min": -10,
      "max": 10,
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "korBufor": {
      "rodzaj": "liczba",
      "min": -10,
      "max": 10,
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "korUFO": {
      "rodzaj": "liczba",
      "min": -10,
      "max": 10,
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "korZbiornik": {
      "rodzaj": "liczba",
      "min": -10,
      "max": 10,
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "ktbc": {
      "rodzaj": "liczba",
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "ktbt": {
      "rodzaj": "liczba",
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "ktzbb": {
      "rodzaj": "liczba",
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "ktzjb": {
      "rodzaj": "liczba",
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "light": {
      "rodzaj": "wl_wyl",
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "maleZrzuty": {
      "rodzaj": "wl_wyl",
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "maxOLM": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 100,
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "minimalnyOLM": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 100,
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "mixer": {
      "rodzaj": "wl_wyl",
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "mocRobocza": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 100,
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "praca": {
      "rodzaj": "wl_wyl",
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "pracaBuforem": {
      "rodzaj": "wl_wyl",
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "proces": {
      "rodzaj": "lista",
      "wartosci": [
        1,
        2,
        3
      ],
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "stab1czas": {
      "rodzaj": "liczba",
      "min": 0,
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "stab2czas": {
      "rodzaj": "liczba",
      "min": 0,
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "stab3czas": {
      "rodzaj": "liczba",
      "min": 0,
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "stopTime": {
      "rodzaj": "liczba",
      "min": 0,
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "tempH2oStop": {
      "rodzaj": "liczba",
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "tempUFOstop": {
      "rodzaj": "liczba",
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "tempZacierania": {
      "rodzaj": "liczba",
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "trybAuto": {
      "rodzaj": "wl_wyl",
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "ustawTempDnia": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 120,
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    },
    "zacier": {
      "rodzaj": "wl_wyl",
      "potwierdzenie": "wyslano",
      "poziom": "sterowanie"
    }
  },
  "akcje": {
    "fabryczne": {
      "poziom": "niszczaca",
      "skutek": "parowanie",
      "czas_s": 60
    },
    "reset": {
      "poziom": "restart",
      "skutek": "online",
      "czas_s": 180
    },
    "resetWiFi": {
      "poziom": "niszczaca",
      "skutek": "parowanie",
      "czas_s": 60
    }
  },
  "zestawy": {
    "ustawienia": {
      "pola": [
        "ileZrzutow",
        "czasLM",
        "mocRobocza",
        "minimalnyOLM",
        "maxOLM",
        "abratek",
        "NTC",
        "maleZrzuty",
        "pracaBuforem",
        "czasPlukania",
        "proces",
        "zacier",
        "tempZacierania",
        "korUFO",
        "kor10p",
        "korBufor",
        "korZbiornik",
        "ktzjb",
        "ktbc",
        "stopTime",
        "ktzbb",
        "ktbt",
        "deltaTempDnia",
        "histTempDnia",
        "stab1czas",
        "stab3czas",
        "stab2czas",
        "deltaBufor",
        "tempUFOstop",
        "tempH2oStop",
        "G2rob",
        "G3rob"
      ],
      "poziom": "sterowanie"
    }
  },
  "czas_potwierdzenia_s": 10
} as const;

/** Etapy procesu po stanie widoku (`state`), w kolejności firmware; `procesy` pusta = każdy typ procesu. */
export const ETAPY_STEROWNIK650 = [
  {
    "nazwa": "Rozgrzewanie",
    "stany": [
      "ROZGRZEWANIE"
    ],
    "procesy": []
  },
  {
    "nazwa": "Stabilizacja",
    "stany": [
      "STABILIZACJA"
    ],
    "procesy": [
      1
    ]
  },
  {
    "nazwa": "Przedgon LM",
    "stany": [
      "ODBIOR_PRZEDGONU_LM"
    ],
    "procesy": [
      1
    ]
  },
  {
    "nazwa": "Stab. końcowa",
    "stany": [
      "STABILIZACJA_KONCOWA"
    ],
    "procesy": [
      1,
      2
    ]
  },
  {
    "nazwa": "Płukanie OLM",
    "stany": [
      "PLUKANIE_OLM"
    ],
    "procesy": [
      1,
      2
    ]
  },
  {
    "nazwa": "Odbiór OLM",
    "stany": [
      "ODBIOR_OLM",
      "SKOK_10P_STABILIZUJE"
    ],
    "procesy": [
      1,
      2
    ]
  }
] as const;

/** Kanały wykresu (numer w próbkach i w punkcie na żywo `widok.wykres`) z nazwą domyślną z opisu linii. */
export const KANALY_STEROWNIK650 = [
  {
    "idx": 0,
    "nazwa": "Skraplacz",
    "ukryty": false,
    "zimny": false
  },
  {
    "idx": 1,
    "nazwa": "Woda IN",
    "ukryty": false,
    "zimny": true
  },
  {
    "idx": 2,
    "nazwa": "10-ta półka",
    "ukryty": false,
    "zimny": false
  },
  {
    "idx": 3,
    "nazwa": "Bufor",
    "ukryty": false,
    "zimny": false
  },
  {
    "idx": 4,
    "nazwa": "Zbiornik",
    "ukryty": false,
    "zimny": false
  },
  {
    "idx": 5,
    "nazwa": "Płaszcz",
    "ukryty": false,
    "zimny": false
  }
] as const;

/** Progi koloru temperatury (KN-20): poziom = liczba progów ≤ wartości, kolor `--iot-temp-<poziom+1>`. */
export const PROGI_KOLORU_STEROWNIK650 = [35,70,78,86,93] as const;

/** Nazwy kodów firmware dla człowieka (programy, fazy - Type.Names); kod spoza słownika bez zmian. */
export const NAZWY_STEROWNIK650: Readonly<Record<string, string>> = {"BLAD_POMIARU":"Błąd pomiaru","BRAK_CZUJNIKOW":"Brak czujników","DESTYLACJA":"Destylacja","KONIEC":"Koniec","ODBIOR_OLM":"Odbiór OLM","ODBIOR_PRZEDGONU_LM":"Odbiór przedgonu LM","PLUKANIE_OLM":"Płukanie OLM","ROZGRZEWANIE":"Rozgrzewanie","SKOK_10P_STABILIZUJE":"Skok 10P · stabilizacja","STABILIZACJA":"Stabilizacja","STABILIZACJA_KONCOWA":"Stabilizacja końcowa","STOP":"Stop","STOP_AWARIA":"Stop · awaria","STOP_KOMUNIKACJA":"Stop · komunikacja","STOP_PRZEGRZANIE":"Stop · przegrzanie"};

